import React from 'react';

export default function Cookies() {
  return (
    <main className="page-transition min-h-screen flex justify-center items-center">
      <div className="max-w-xl text-center">
        <h1 className="text-xl uppercase tracking-widest mb-8">Cookie Policy</h1>
        <p className="text-gray-500 text-sm leading-loose">
          We use essential cookies to ensure our website works properly. No tracking, no ads. Just music.
        </p>
      </div>
    </main>
  );
}
